import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "barArrowButtonSlotContent" };
const _hoisted_2 = ["href"];
const _hoisted_3 = { class: "centered" };
const _hoisted_4 = ["href"];
const _hoisted_5 = {
    class: "countCircle",
    style: { "background": "var(--background-color-alt5)", "color": "var(--text-color)" }
};
const _hoisted_6 = { href: "/#/money?show=true" };
const _hoisted_7 = {
    class: "countCircle",
    style: { "background": "var(--background-color-alt6)", "color": "var(--text-color)" }
};
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { key: 1 };
const _hoisted_10 = { href: "/#/money?show=true" };
const _hoisted_11 = {
    class: "countCircle",
    style: { "background": "var(--background-color-primary)", "color": "white" }
};
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { key: 1 };
import BarArrowButton from './BarArrowButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecentTransactionsInfoPanel',
    props: {
        today: {},
        bankInfo: {}
    },
    setup(__props) {
        const props = __props;
        function determineUrl() {
            if (props.bankInfo.untaggedTransactionsCurrentCycleCount > 0) {
                return '/#/TransactionBulk';
            }
            else {
                return '/#/SpendingAnalysis';
            }
        }
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createBlock(BarArrowButton, {
                flex: true,
                large: true,
                class: "linkAccounts",
                title: "Recent Transactions",
                href: _ctx.bankInfo.untaggedTransactionsCurrentCycleCount > 0 ? '/#/TransactionBulk' : '/#/SpendingAnalysis'
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("a", {
                            href: _ctx.bankInfo.untaggedTransactionsCurrentCycleCount > 0 ? '/#/TransactionBulk' : '/#/SpendingAnalysis'
                        }, [
                            _createElementVNode("p", null, [
                                _cache[0] || (_cache[0] = _createTextVNode("You've got ")),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.bankInfo.untaggedTransactionsCurrentCycleCount) + " new " + _toDisplayString(_ctx.bankInfo.untaggedTransactionsCurrentCycleCount == 1 ? 'transaction' : 'transactions'), 1),
                                _cache[1] || (_cache[1] = _createTextVNode(" to tag."))
                            ]),
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                _createElementVNode("a", {
                                                    href: determineUrl()
                                                }, [
                                                    _createElementVNode("div", _hoisted_5, [
                                                        _cache[2] || (_cache[2] = _createElementVNode("span", null, "To Tag", -1)),
                                                        _createElementVNode("div", null, _toDisplayString(_ctx.bankInfo.untaggedTransactionsCurrentCycleCount), 1)
                                                    ])
                                                ], 8, _hoisted_4)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                _createElementVNode("a", _hoisted_6, [
                                                    _createElementVNode("div", _hoisted_7, [
                                                        (_ctx.bankInfo.recentTransactions[0][0].timestampString == _ctx.today)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Today"))
                                                            : _createCommentVNode("", true),
                                                        (_ctx.bankInfo.recentTransactions[0][0].timestampString != _ctx.today)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.bankInfo.recentTransactions[0][0].timestampString), 1))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("div", null, _toDisplayString(_ctx.bankInfo.recentTransactions[0].length), 1)
                                                    ])
                                                ])
                                            ]),
                                            _: 1
                                        }),
                                        (_ctx.bankInfo.recentTransactions[1])
                                            ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("a", _hoisted_10, [
                                                        _createElementVNode("div", _hoisted_11, [
                                                            (_ctx.bankInfo.recentTransactions[1][0].timestampString == _ctx.today)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Today"))
                                                                : _createCommentVNode("", true),
                                                            (_ctx.bankInfo.recentTransactions[1][0].timestampString != _ctx.today)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.bankInfo.recentTransactions[1][0].timestampString), 1))
                                                                : _createCommentVNode("", true),
                                                            _createElementVNode("div", null, _toDisplayString(_ctx.bankInfo.recentTransactions[1].length), 1)
                                                        ])
                                                    ])
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                })
                            ])
                        ], 8, _hoisted_2)
                    ])
                ]),
                _: 1
            }, 8, ["href"]));
        };
    }
});
